/**
 * RentabilidadeTopWidget — Top 5 pedidos mais lucrativos do periodo.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterRentabilidadePeriodo } from "../../../services/financeiro";

import { CardBody, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "rentabilidade_top",
  label: "Pedidos mais lucrativos",
  descricao: "Top 5 pedidos ENTREGUE com maior lucro liquido no periodo.",
  categoria: "Financeiro",
  permissoes: ["financeiro:view"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  return await obterRentabilidadePeriodo(request);
}

function fmt(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function Widget({ dados }) {
  const ranking = Array.isArray(dados?.ranking)
    ? dados.ranking
    : Array.isArray(dados)
    ? dados
    : [];
  if (ranking.length === 0) {
    return (
      <>
        <CardBody>
          <KpiSub>Nenhum pedido entregue no periodo.</KpiSub>
        </CardBody>
        <CardFooter>
          <LinkLight as={Link} to="/financeiro/rentabilidade">Ver detalhes</LinkLight>
        </CardFooter>
      </>
    );
  }
  return (
    <>
      <CardBody>
        <KpiSub>{ranking.length} pedidos no periodo</KpiSub>
        <ul style={{ listStyle: "none", padding: 0, margin: 6, display: "flex", flexDirection: "column", gap: 4 }}>
          {ranking.slice(0, 5).map((p, i) => (
            <li key={p.id || p.numero || i} style={{ display: "flex", justifyContent: "space-between", fontSize: "0.85rem" }}>
              <span>{p.numero || p.id || `Pedido ${i + 1}`}</span>
              <strong>{fmt(p.lucro_liquido ?? p.lucro)}</strong>
            </li>
          ))}
        </ul>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/financeiro/rentabilidade">Ver ranking completo</LinkLight>
      </CardFooter>
    </>
  );
}
